import React from "react";
import type { IAppUpload } from "./AppUpload";
import { UploadContentComponent } from "./content/UploadContentComponent";
import { AppComponent } from "../shared-components/AppComponent";

interface IUploadMasterMasterComponentProps {
    appUpload: IAppUpload;
}

export class UploadMasterComponent extends React.Component<IUploadMasterMasterComponentProps> {
    componentDidMount() {
        window.onbeforeunload = this.onBeforeUnload;
    }

    componentWillUnmount() {
        window.onbeforeunload = null;
    }

    onBeforeUnload = (e: BeforeUnloadEvent) => {
        const { stores } = this.props.appUpload;
        const { uploadStore } = stores;

        if (uploadStore.somethingIsUploading) {
            const { resourcesStore } = stores;
            const { resources } = resourcesStore;

            const message = resources.UploadCloseTabInfo;
            e.preventDefault();
            e.returnValue = message;
            return message;
        }
    };

    render() {
        const { appUpload } = this.props;
        const { stores } = appUpload;

        return (
            <AppComponent appStores={stores}>
                <UploadContentComponent />
            </AppComponent>
        );
    }
}
